// this approach corrects the select 2 to be duplicated when clicking the back button.
$(document).on("turbo:before-cache", function () {
  $(".select2-hidden-accessible").select2("destroy");
});

window.onMobile = function () {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return true;
  } else {
    return false;
  }
};

window.replaceUrlParam = function (url, paramName, paramValue) {
  if (paramValue == null) {
    paramValue = "";
  }
  var pattern = new RegExp("\\b(" + paramName + "=).*?(&|#|$)");
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, "$1" + paramValue + "$2");
  }
  url = url.replace(/[?#]$/, "");
  return (
    url + (url.indexOf("?") > 0 ? "&" : "?") + paramName + "=" + paramValue
  );
};

window.getISOLocalDate = function(date) {
  var z = function(num) {
    return num < 10 ? `0${num}` : num;
  }
  return `${date.getFullYear()}-${z(date.getMonth() + 1)}-${z(date.getDate())}`
}

window.pieChartOptions = {
  chart: {
    type: "pie",
    spacingBottom: 0,
    spacingTop: 0,
  },
  title: {
    text: null,
  },
  tooltip: {
    formatter: function () {
      return `<div class="chart-tooltip">${this.point.name}: ${this.point.y}</div>`;
    },
    useHTML: true,
  },
  accessibility: {
    point: {
      valueSuffix: "%",
    },
  },
  plotOptions: {
    pie: {
      cursor: "pointer",
      animation: false,
      dataLabels: {
        enabled: true,
        format:
          '<div class="chart-tooltip">{point.name}: {point.percentage:.1f} %</div>',
      },
    },
  },
  credits: {
    enabled: false,
  },
};

window.trendChartOptions = {
  chart: {
    height: 240,
    type: "line",
    spacingBottom: 0,
  },
  title: {
    text: null,
  },
  xAxis: {
    crosshair: true,
    type: "datetime",
  },
  yAxis: {
    allowDecimals: false,
    title: { text: null },
    min: 0,
  },
  plotOptions: {
    line: {
      lineWidth: 3,
      animation: false,
    },
    series: {
      marker: {
        enabled: false,
        radius: 2,
        symbol: "circle",
      },
      states: {
        hover: {
          lineWidthPlus: 0,
          radiusPlus: 0,
          halo: {
            size: 5,
          },
        },
        inactive: {
          opacity: 0.9,
        },
      },
    },
  },
  lang: {
    noData: "No data",
  },
  legend: {
    align: "right",
    symbolHeight: 12,
    symbolWidth: 12,
    symbolRadius: 2,
    itemMarginBottom: 10,
    itemStyle: {
      color: "#666",
      fontWeight: "normal",
    },
  },
  tooltip: {
    formatter: function () {
      var content = `<p>${this.points[0].point.options.date || this.points[0].series.name}</p><p><span class="square" style="background:${this.points[0].color}"></span>${this.points[0].y}</p>`;
      if (this.points.length > 1) {
        content += `<hr /><p>${this.points[1].point.options.date || this.points[1].series.name}</p><p><span class="square" style="background:${this.points[1].color}"></span>${this.points[1].y}</p>`;
      }
      return `<div class="chart-tooltip"><div class="container">${content}</div></div>`;
    },
    padding: 0,
    shared: true,
    useHTML: true,
    outside: true
  },
  credits: {
    enabled: false,
  },
};

Highcharts.seriesTypes.line.prototype.drawLegendSymbol =
  Highcharts.seriesTypes.column.prototype.drawLegendSymbol;

window.setChartPlotLines = function (chart) {
  var positions = chart.xAxis[0].tickPositions;
  for (var i = 0; i < positions.length; i++) {
    chart.xAxis[0].addPlotLine({
      value: positions[i],
      dashStyle: "Dash",
      color: "#dfe3e8",
      width: 1,
    });
  }
};

window.showInPopupWindow = function (title, body, footer, wide, logoPath, showCloseButton) {
  var header;
  var closeButton = '';
  if(showCloseButton != false){
    closeButton = `
      <button id="modalCloseButton" type="button" class="btn btn-xs btn-icon btn-soft-secondary" data-dismiss="modal" aria-label="Close">
        <svg aria-hidden="true" width="10" height="10" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="M11.5,9.5l5-5c0.2-0.2,0.2-0.6-0.1-0.9l-1-1c-0.3-0.3-0.7-0.3-0.9-0.1l-5,5l-5-5C4.3,2.3,3.9,2.4,3.6,2.6l-1,1 C2.4,3.9,2.3,4.3,2.5,4.5l5,5l-5,5c-0.2,0.2-0.2,0.6,0.1,0.9l1,1c0.3,0.3,0.7,0.3,0.9,0.1l5-5l5,5c0.2,0.2,0.6,0.2,0.9-0.1l1-1 c0.3-0.3,0.3-0.7,0.1-0.9L11.5,9.5z"/>
        </svg>
      </button>
    `;
  }
  if (title) {
    header = `
      <div class="modal-header">
        <h5 class="modal-title">${title}</h5>
        ${closeButton}
      </div>
    `;
  } else {
    header = `
      <div class="modal-top-cover bg-primary text-center">
        <figure class="position-absolute right-0 bottom-0 left-0">
          <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
            <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>
          </svg>
        </figure>
        <div class="modal-close">${closeButton}</div>
      </div>
      <div class="modal-top-cover-avatar">
        <div class="avatar avatar-lg avatar-circle avatar-border-lg avatar-centered shadow-soft" style="background: white">
          <img src="${logoPath}" alt="Logo">
        </div>
      </div>
    `;
  }
  var content = `
    <div class="modal-dialog ${
      wide ? "modal-lg" : ""
    } modal-dialog-centered" role="document">
      <div class="modal-content">
        ${header}
        <div class="modal-body">
          ${body}
        </div>
        <div class="modal-footer">
          ${footer}
        </div>
      </div>
    </div>
  `
  $('#modalWindow').html(content);
  $('#modalWindow').modal();

  $('#modalWindow').on('shown.bs.modal', function () {
    $('#modalWindow form input:text:visible:first').focus();
  }) 
}

window.showToast = function(text, error, delay) {
  // Reset toast container
  if(window.moveUpTimeout){
    clearTimeout(window.moveUpTimeout);
  }
  if(window.hideToastTimeout){
    clearTimeout(window.hideToastTimeout);
  }
  $(".toast-container").css('bottom', '-100px');

  $(".toast-container .toast-text").html(text);
  var wrapper = $(".toast-container .toast-wrapper");
  if(error){
    wrapper.addClass("error");
  }else{
    wrapper.removeClass("error");
  }

  if(!delay){
    delay = 4000;
  }

  var moveUp = function(delay){
    var dom = $(".toast-container");
    var bottom = parseInt(dom.css('bottom'));
    if(bottom < 0){
      dom.css('bottom', `${bottom + 10}px`);
      window.moveUpTimeout = setTimeout(function(){moveUp(delay)}, 5);
    } else {
      window.hideToastTimeout = setTimeout(hideToast, delay);
    }
  }
  moveUp(delay);
}

window.hideToast = function() {
  var dom = $(".toast-container");
  var bottom = parseInt(dom.css('bottom'));
  if(bottom > -100){
    dom.css('bottom', `${bottom - 10}px`);
    setTimeout(hideToast, 5);
  }
}

$(document).on("turbo:load", function () {
  $('[data-toggle="tooltip"]').tooltip();
  $(window).off("resize scroll");
});
